(() => {
  const OPEN_SEL = '[data-modal-open]';
  const CLOSE_SEL = '[data-modal-close]';
  const MODAL_SEL = '[data-modal]';

  const state = { active: null, lastFocus: null };

  const lockScroll = (locked) => {
    document.documentElement.classList.toggle('modal-open', locked);
  };

  const getModal = (selectorOrId) => {
    if (!selectorOrId) return null;
    if (selectorOrId.startsWith('#')) return document.querySelector(selectorOrId);
    return document.getElementById(selectorOrId);
  };

  const openModal = (modal) => {
    if (!modal) return;

    if (state.active && state.active !== modal) closeModal(state.active);

    state.lastFocus = document.activeElement;

    const pct = getGlobalSubscriptionDiscountPercent();
    if (pct != null) {
      modal.querySelectorAll('[data-sub-discount]').forEach(el => {
        el.textContent = `${pct}%`;
      });
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    lockScroll(true);

    const panel = modal.querySelector('.c-modal__panel');
    panel?.focus({ preventScroll: true });

    state.active = modal;
  };

  const closeModal = (modal) => {
    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    lockScroll(false);

    if (state.lastFocus && typeof state.lastFocus.focus === 'function') {
      state.lastFocus.focus({ preventScroll: true });
    }

    if (state.active === modal) state.active = null;
  };

  document.addEventListener('click', (e) => {
    const opener = e.target.closest(OPEN_SEL);
    if (opener) {
      openModal(getModal(opener.getAttribute('data-modal-open')));
      return;
    }

    const closer = e.target.closest(CLOSE_SEL);
    if (closer) {
      closeModal(closer.closest(MODAL_SEL));
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && state.active) closeModal(state.active);
  });

  function getGlobalSubscriptionDiscountPercent() {
    const rules = window.__global_discounts || [];
    const globalRule = rules.find(r => (!r?.pids?.length) && (!r?.vids?.length));
    const pct = globalRule?.subscription_discount;
    const n = Number(pct);
    return Number.isFinite(n) ? n : null;
  }

})();
